import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ArrowRight } from "lucide-react";
import { usePrefs } from "@/context/PrefsContext";

export function OnboardingChecklist({ ob }) {
  const { t } = usePrefs();
  if (!ob || ob.complete) return null;
  const steps = [
    { id: "target", done: ob.target_set && ob.exam_date_set, label: t("ob1"), to: "/settings" },
    { id: "assessment", done: ob.assessment_done, label: t("ob2"), to: "/assessment" },
    { id: "module", done: ob.module_started, label: t("ob3"), to: "/modules" },
  ];
  const next = steps.find((s) => !s.done);
  const doneCount = steps.filter((s) => s.done).length;
  return (
    <div className="soft-card border-secondary/30 bg-secondary/[0.04] p-5 sm:p-6" data-testid="onboarding-checklist">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><p className="text-xs uppercase tracking-wide text-secondary">{t("onboardingTitle")} · {doneCount}/3</p><p className="mt-1 text-sm text-muted-foreground">{t("onboardingDesc")}</p></div>
        {next && <Link to={next.to} data-testid="onboarding-next-button" className="inline-flex items-center gap-2 rounded-full bg-secondary px-4 py-2 text-xs font-semibold text-white transition-transform hover:-translate-y-0.5">{next.label}<ArrowRight className="h-3.5 w-3.5" /></Link>}
      </div>
      <ol className="mt-4 grid gap-2 sm:grid-cols-3">
        {steps.map((s, i) => (
          <li key={s.id}>
            <Link to={s.to} data-testid={`onboarding-step-${s.id}`} data-done={s.done} className={`flex items-center gap-3 rounded-xl border px-3 py-2.5 text-sm transition-colors ${s.done ? "border-sage/40 bg-sage-soft/60 text-sage" : s === next ? "border-secondary/50 bg-card font-medium" : "border-border bg-card text-muted-foreground"}`}>
              {s.done ? <CheckCircle2 className="h-4 w-4 shrink-0" /> : <Circle className="h-4 w-4 shrink-0" />}
              <span className="text-[11px] font-semibold">{i + 1}</span><span className="min-w-0 flex-1 leading-tight">{s.label}</span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}
